// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"700":"36d4f7f1","4150":"a98b0106","6941":"23735b4e"}[chunkId] + ".chunk.css";
};